/**
 * Cut a piece from the middle to make a shorter URL
 * show the protocol, domain and the last part of the path,
 * use ... for the middle part
 * @param url - The URL to truncate
 * @returns The truncated URL
 */
export default function truncateUrl(url: string): string {
    const protocol = url.match(/^https?:\/\//)?.[0] || ''
    const domainOnly = url.match(/^https?:\/\/([^/]+)/)?.[1] || ''
    const path = url.match(/[^/]+$/)?.[0] || ''
    return `${protocol}${domainOnly}...${path}`
}
